import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";

Object.assign(buttonSizeVariants, {
    small: {
        height: 32, // Height applied as "min-height" (px)
        fontSize: 14, // Font size (px)
        padding: pxToRem(0, 14), // Css applied to the padding property "padding: [VALUE];"
        icon: 14, // Icon size (px)
        iconPadding: 5, // Spacing between the icon and the text (px)
    },
    medium: {
        height: 40,
        fontSize: 16,
        padding: pxToRem(0, 16),
        icon: 16,
        iconPadding: 6,
    },
    large: {
        height: 45,
        fontSize: 16,
        padding: pxToRem(0, 16),
        icon: 16,
        iconPadding: 6,
    },
    xlarge: {
        height: 45,
        fontSize: 18,
        padding: pxToRem(0, 18),
        icon: 18,
        iconPadding: 7,
    },
});
